/**
 * Thin wrapper that mounts RiskAssessmentWorkspace inside the evaluation
 * shell. All risks UI — RiskProfileSummary, RiskRegisterPanel, HeatMap,
 * RiskFormSlideOver — lives in `components/risks/` (G1 / G2 / G3).
 *
 * The legacy single-column layout is gone. The legacy `RiskForm.tsx` dialog
 * remains on disk as an orphan (replaced by `risks/RiskFormSlideOver.tsx`);
 * cleanup deferred to the closing-sweep pass.
 */

import { useOutletContext } from 'react-router-dom'
import type { EvaluationOutletContext } from '../Evaluations_ShowCN'
import RiskAssessmentWorkspace from './risks/RiskAssessmentWorkspace'

const EvaluationRisks = () => {
	const { evalId } = useOutletContext<EvaluationOutletContext>()
	return <RiskAssessmentWorkspace evalId={evalId} />
}

export default EvaluationRisks
